import { useMutation } from "@apollo/client";
import { CREATE_COMPANY_DOCUMENT_CONFIRMATION_FOR_ACTIVE_PERSONS } from "../api/create-company-document-confirmation-for-active-persons";
import { FieldsType } from "./types";
import { GET_READ_UNREAD_PERSONS } from "@/modules/documents/widgets/company-document-statistic/api/get-read-unread-persons";

export function useCreateCompanyDocumentConfirmationForActivePersons() {
  const [createConfirmation, { loading }] = useMutation(
    CREATE_COMPANY_DOCUMENT_CONFIRMATION_FOR_ACTIVE_PERSONS,
    {
      refetchQueries: [GET_READ_UNREAD_PERSONS],
    },
  );

  const create = async (variables: FieldsType) => {
    await createConfirmation({ variables });
  };

  return {
    create,
    loading,
  };
}
